import { render, staticRenderFns } from "./MRentalGeneralDataEditor.yaml?vue&type=template&id=5f023eca&component"
import script from "./MRentalGeneralDataEditor.yaml?vue&type=script&lang=ts&component"
export * from "./MRentalGeneralDataEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports